module.exports = __webpack_public_path__ + "img/euromedi_logo.6e2d8f41.png";